// Canonical U.S. schools list, sourced from the National Student Clearinghouse
// Electronic Verification participants (5,895 institutions after cleaning).
//
// Each row: { code, name, city, state }
//   code  — NSC school code (OPEID-like). Stable identifier.
//   name  — Display name (title-cased, acronyms preserved).
//   city  — City (title-cased).
//   state — Two-letter USPS state code.
//
// The dataset is fully static and safe to import into a client bundle.
// When the backend arrives, this module can be replaced with an API call
// (fetch `/api/schools?q=...`) without any change to consumers, since the
// public shape stays the same.

import schools from "./schools.json";

export const SCHOOLS = schools;

// Back-compat: some UI still consumes just the school-name strings.
export const US_COLLEGES = schools.map((s) => s.name);
